import React from 'react';
import { Row, Col } from 'antd';
import AnalyticsCard from '../../components/shared/AnalyticsCard';
import { mockRevenueData } from '../data/mockData';

const RevenueOverview: React.FC = () => {
  const { overview } = mockRevenueData;

  // Calculate metrics
  const monthlyGrowth = ((overview.monthlyRevenue - 78900) / 78900) * 100; // vs previous month
  const yearlyGrowth = ((overview.yearlyRevenue - 425000) / 425000) * 100; // vs previous year
  const projectedGrowth = ((overview.projectedRevenue - overview.yearlyRevenue) / overview.yearlyRevenue) * 100;

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={6}>
          <AnalyticsCard
            title="Total Revenue (YTD)"
            value={overview.totalRevenue}
            format="currency"
            trend="up"
            change={yearlyGrowth}
            subtitle="vs last year"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="Monthly Revenue"
            value={overview.monthlyRevenue}
            format="currency"
            trend="up"
            change={monthlyGrowth}
            subtitle="vs last month"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="Projected Annual Revenue"
            value={overview.projectedRevenue}
            format="currency"
            trend="up"
            change={projectedGrowth}
            subtitle="growth projection"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="Average Revenue per Client"
            value={1970}
            format="currency"
            trend="up"
            change={7.6}
            subtitle="vs last month"
          />
        </Col>
      </Row>

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col span={6}>
          <AnalyticsCard
            title="Monthly Recurring Revenue"
            value={93500}
            format="currency"
            trend="up"
            change={5.3}
            subtitle="MRR"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="Annual Recurring Revenue"
            value={1122000}
            format="currency"
            trend="up"
            change={15.8}
            subtitle="ARR"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="Customer Lifetime Value"
            value={4850}
            format="currency"
            trend="up"
            change={6.6}
            subtitle="LTV"
          />
        </Col>
        <Col span={6}>
          <AnalyticsCard
            title="Churn Rate"
            value={7.2}
            format="percentage"
            trend="down"
            change={-1.8}
            subtitle="monthly"
          />
        </Col>
      </Row>
    </div>
  );
};

export default RevenueOverview; 